import { type Theme } from '../../../../../theme';
import { type ButtonStyles } from '../button.types';

export const getSecondaryButton = (theme: Theme): ButtonStyles => ({
  base: {
    color: theme.button.secondary.label,
    backgroundColor: theme.button.secondary.default,
    border: `1px solid ${theme.button.secondary.border}`,
    boxShadow:
      '0 -4px 4px 0 rgba(0, 0, 0, 0.02) inset, 0 1px 0 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.05)',

    '&:hover': {
      backgroundColor: theme.button.secondary.hover,
    },

    '&:active, &:focus:not(:focus-visible)': {
      backgroundColor: theme.button.secondary.pressed,
      outline: 'none',
      border: `1px solid ${theme.palette.neutral.grey[300]}`,
      boxShadow: `0 1px 0 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 -4px 4px 0 rgba(0, 0, 0, 0.02) inset`,
    },

    '&:focus': {
      backgroundColor:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
    },

    '&:focus-visible': {
      backgroundColor:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
      outline: `2.5px solid ${theme.button.focused.default}`,
      outlineOffset: 4,
    },
  },
  active: {},
  isLoading: {},
  disabled: {
    backgroundColor: theme.button.secondary.disabled,
    color: theme.button.disabled.label,
    cursor: 'not-allowed',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'none',
    },
    '&:active, &:focus:not(:focus-visible)': {
      backgroundColor: theme.button.secondary.default,
      outline: 'none',
      boxShadow: 'none',
    },
    svg: {
      color: theme.button.ghost.disabled,
    },
  },
});
